export default __webpack_public_path__ + "static/media/regina.9012dde1.png";